import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

// Create a baseQuery with auth headers
const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/dashboard/`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", true);
    }
    return headers;
  },
});

export const ReportingAnalyticsSlice = createApi({
  reducerPath: "ReportingAnalyticsSlice",
  baseQuery: baseQuery,
  tagTypes: ["reporting"],
  endpoints: (builder) => ({
    // GET all reporting with filters
    getAllReporting: builder.query({
      query: ({ startDate, endDate }) => {
        const params = new URLSearchParams();

        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        return `reporting-analytics?${params.toString()}`;
      },
      providesTags: ["reporting"],
    }),
  }),
});

// Export hooks for usage in components
export const { useGetAllReportingQuery } = ReportingAnalyticsSlice;
